import PropTypes from 'prop-types';
import * as React from 'react';
import SvgContainer from './SvgContainer';

export const defaultSvgIconProps = {
  size: 'initial'
};

export const LinkedinIcon = ({ size }) => {
  return (
    <SvgContainer size={size}>
      <svg
        fill="#FFFFFF"
        width="24"
        height="24"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M 8.6425781 4 C 7.1835781 4 6 5.181625 6 6.640625 C 6 8.099625 7.182625 9.3085938 8.640625 9.3085938 C 10.098625 9.3085938 11.283203 8.099625 11.283203 6.640625 C 11.283203 5.182625 10.101578 4 8.6425781 4 z M 21.535156 11 C 19.316156 11 18.0465 12.160453 17.4375 13.314453 L 17.373047 13.314453 L 17.373047 11.310547 L 13 11.310547 L 13 26 L 17.556641 26 L 17.556641 18.728516 C 17.556641 16.812516 17.701266 14.960938 20.072266 14.960938 C 22.409266 14.960937 22.443359 17.145609 22.443359 18.849609 L 22.443359 26 L 26.994141 26 L 27 26 L 27 17.931641 C 27 13.983641 26.151156 11 21.535156 11 z M 6.3632812 11.310547 L 6.3632812 26 L 10.923828 26 L 10.923828 11.310547 L 6.3632812 11.310547 z" />
      </svg>
    </SvgContainer>
  );
};

LinkedinIcon.propTypes = {
  size: PropTypes.string
};

LinkedinIcon.defaultProps = defaultSvgIconProps;

export default LinkedinIcon;
